const DISPLAY_MODE_STORAGE_KEY = "cartazPratico.displayMode.v1";
const DISPLAY_MODE_DESKTOP = "desktop";
const DISPLAY_MODE_TABLET = "tablet";

const normalizeDisplayMode = (value) =>
  value === DISPLAY_MODE_TABLET ? DISPLAY_MODE_TABLET : DISPLAY_MODE_DESKTOP;

const readStoredDisplayMode = () => {
  try {
    if (typeof window === "undefined" || !window.localStorage) {
      return DISPLAY_MODE_DESKTOP;
    }

    return normalizeDisplayMode(
      window.localStorage.getItem(DISPLAY_MODE_STORAGE_KEY)
    );
  } catch (error) {
    return DISPLAY_MODE_DESKTOP;
  }
};

const persistDisplayMode = (displayMode) => {
  try {
    if (typeof window !== "undefined" && window.localStorage) {
      window.localStorage.setItem(DISPLAY_MODE_STORAGE_KEY, displayMode);
    }
  } catch (error) {
    // O modo continua funcional mesmo quando o navegador bloqueia o storage.
  }
};

const state = {
  displayMode: readStoredDisplayMode(),
};

const getters = {
  getDisplayMode(state) {
    return state.displayMode;
  },
  getIsTabletMode(state) {
    return state.displayMode === DISPLAY_MODE_TABLET;
  },
};

const mutations = {
  SET_DISPLAY_MODE(state, displayMode) {
    state.displayMode = normalizeDisplayMode(displayMode);
  },
};

const actions = {
  setDisplayMode({ commit }, displayMode) {
    const normalizedDisplayMode = normalizeDisplayMode(displayMode);

    commit("SET_DISPLAY_MODE", normalizedDisplayMode);
    persistDisplayMode(normalizedDisplayMode);
  },
  toggleDisplayMode({ dispatch, state }) {
    return dispatch(
      "setDisplayMode",
      state.displayMode === DISPLAY_MODE_TABLET
        ? DISPLAY_MODE_DESKTOP
        : DISPLAY_MODE_TABLET
    );
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
